import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Upload } from "lucide-react";

const TEMPLATE = "Lead ID,First Name,Last Name,Phone,Email,Address,City,State,Zip,Loan Purpose,Loan Amount,Property Value,Mortgage Balance,Credit\n" +
  "A1001,Jane,Sample,4075550100,jane@example.com,1 Main St,Orlando,FL,32801,Refinance,300000,420000,250000,Good\n";

export const MarketLeadImport = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const template = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([TEMPLATE], { type: "text/csv" }));
    a.download = "marketplace-leads-template.csv"; a.click();
  };
  const upload = async () => {
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { const { data } = await api.post("/admin/marketplace/import", fd); setRes(data); (data.added ? toast.success : toast.info)(`${data.added} lead${data.added === 1 ? "" : "s"} added to the Marketplace`); onDone?.(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const close = (v) => { setOpen(v); if (!v) { setRes(null); setFile(null); } };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="market-import-btn"><Upload className="mr-1.5 h-4 w-4" />Import CSV</Button>
      <Dialog open={open} onOpenChange={close}>
        <DialogContent data-testid="market-import-dialog">
          <DialogHeader><DialogTitle>Import leads into the Marketplace</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">CSV or Excel (.xlsx), first row = column headers. Each lead needs a phone or email. Recognised columns include Lead ID, First Name, Last Name, Phone, Email, Address, City, State, Zip, Loan Purpose, Loan Amount, Property Value, Mortgage Balance and Credit. Leads already in the Marketplace are skipped. Up to 5,000 rows. MLOs get one text when the import finishes.</p>
          <Button variant="link" className="h-auto justify-start p-0 text-sm" onClick={template} data-testid="market-import-template">Download a template</Button>
          <input type="file" accept=".csv,.xlsx,.xlsm,.txt" onChange={(e) => setFile(e.target.files[0] || null)} className="text-sm" data-testid="market-import-file" />
          {res && (
            <div className="rounded-md bg-slate-50 p-3 text-sm" data-testid="market-import-result">
              <div className="font-semibold text-emerald-700">{res.added} added{res.duplicates ? `, ${res.duplicates} already in the Marketplace` : ""}{res.skipped_count ? `, ${res.skipped_count} skipped` : ""}</div>
              {res.skipped.slice(0, 8).map((s) => <div key={s.row} className="text-xs text-slate-600">Row {s.row}: {s.reason}</div>)}
              {res.truncated && <div className="text-xs text-amber-700">Only the first 5,000 rows were read.</div>}
            </div>
          )}
          <DialogFooter><Button onClick={upload} disabled={!file || busy} data-testid="market-import-upload">{busy ? "Importing..." : "Add to Marketplace"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
